const apiEndPoints = {
  //advisor api's
  getAdvisors: '/api/v2/advisors',
  getPalAdvisors: '/api/v2/pal',
  updateAdvisor: '/api/v2/advisors',
  createAdvisor: '/api/v2/advisors',
  updateAdvisorStatus: '/api/v2/advisors/status',
  deleteAdvisor: '/api/v2/advisors/',
  invitePalUser: '/api/v2/pal/invite',
  getPalUserDetails: '/api/v2/pal/invitees',
  uploadAdvisorLogo: '/api/v1/presignedurl/advisor/logo/generate',
  getadvisorprompts: '/api/v1/data/prompts',
  updateAdvisorPrompts: '/api/v1/data/prompts',

  //default adviosr api's 
  defaultAdvisor: '/api/v2/advisor/default',

  //chat-advisor api's
  updateFeedback: '/api/v5/feedback',
  updateGustFeedback: '/rest/v5/conversations/feedback',
  expertAnswer: '/api/v1/expert',
  updateExpertAnswer: '/api/v1/expert',
  getExpertAnswerByMsgId: '/api/v1/expert',
  updateExpertAnswerStatus: '/api/v1/expert/status',

  //image generate for converse message api
  getGenerateImage: '/api/v5/conversations/images',
  //conversation api's
  getPdfLinkForConversations: '/api/v5/conversations/knowledge',
  getGuestPdfLinkForConversations: '/rest/v5/conversations/knowledge',
  getConversationHistory: '/api/v5/conversations/query',
  exportConversations: '/api/v5/conversations/export',
  getConversationMessages: '/api/v5/conversations/query',
  getConversationHistoryMilves: '/api/v4/conversations',
  getSemanticSeachResults: '/api/v5/conversations/search/hybrid',
  getFullTextSearchResults: '/api/v3/conversations/search/text',
  //dashboard api's
  getTotalConversations: '/api/v1/dashboard',
  getDashboardConversations: '/api/v3/dashboard/conversations',
  //knowledge api's
  getPdfLink: '/api/v2/knowledge/view',
  getKnowledgeAdvisorList: '/api/v2/knowledge',
  getAdvisorKnowledgeDetails: '/api/v2/knowledge',
  getKnowledgeMetadataKeys: '/api/v2/knowledge/metadata/keys',
  getPresignedUrl: '/api/v1/knowledge/upload/generate',
  uploadKnowledgeUrl: '/api/v1/knowledge',
  getKnowledgeUrlSources: '/api/v2/knowledge/url/sources',
  uploadUrlSourceList: '/api/v2/knowledge',
  delinkKnowledge: '/api/v2/knowledge',
  deleteKnowledge: '/api/v2/knowledge',
  getExpertAnswer: '/api/v1/expert',
  deleteExpertAnswer: '/api/v1/expert',
  delinkExpertAnswer: '/api/v1/expert',
  updateExpertAnswerMetaData: '/api/v1/expert',
  getAdvisorKnowledgeMetadata: '/api/v2/knowledge/metadata',
  getKnowledgeArticleMetadata: '/api/v2/knowledge/article/metadata',
  updateAdvisorKnowledgeMetadata: '/api/v2/knowledge/metadata',
  metadataDefinitions: '/api/v2/knowledge/metadata/definitions',

  //domain dictionary api's
  dictionary: '/api/v1/dictionary',
  dictionaryQuery: '/api/v1/dictionary/query',
  dictionaryCreate: '/api/v1/dictionary/create',
  dictionaryUpdateKnowledge: '/api/v1/dictionary/update_knowledge',
  dictionaryBulkUpload: '/api/v1/dictionary/bulk_upload',
  updateAdvisorKnowledgeDatabricks: '/api/v2/knowledge',
  trainCreateAdvisorKnowledgeDatabricks: '/api/v1/knowledge',
  getKnowledgeFileTranscript: '/api/v1/knowledge/transcription',
  //settings api's
  inviteUser: '/api/v2/tenant/invite',
  getTeamMembers: '/api/v2/tenant/team',
  getDetails: '/api/v2/tenant',
  getUserProfileDetails: '/api/v2/tenant/user',
  getTenantMetadata: '/api/v2/tenant/metadata',
  updateTenantMetadata: '/api/v2/tenant/metadata',
  tenantMetadataUpload: '/api/v2/tenant/metadata/upload',
  tenantTimezones: '/api/v2/tenant/timezones',

  //settings integration api's
  getGlobalSettings: '/api/v2/settings',
  updateSettings: '/api/v2/settings',

  //settings advisor api's
  getAdvisorAbilities: '/api/v2/settings',

  //FGA api's (users list/get/delete, group members list/add and invite are on v4; the rest stay on v3)
  getFgaAllUsers: '/api/v4/fga/users',
  queryFgaUsers: '/api/v4/fga/users/query',
  deleteAuth0User: '/api/v4/fga/users',
  getFgaUsersGroup: '/api/v4/fga/group',
  getFgaUserResources: '/api/v3/fga/users',
  getFgaGroups: '/api/v3/fga/groups',
  getFgaGroupNames: '/api/v3/fga/group-names',
  getFgaAllResources: '/api/v3/fga/resources',
  getFgaGroupResources: '/api/v3/fga/group',
  addFgaUser: '/api/v4/fga/group',
  removeFgaUser: '/api/v3/fga/group',
  addFgaGroup: '/api/v3/fga/group',
  deleteFgaGroup: '/api/v3/fga/group',
  addFgaResource: '/api/v3/fga/group',
  removeFgaResource: '/api/v3/fga/group',
  fgaInvite: '/api/v4/fga/invite',
  updateUserMetadata: '/api/v2/tenant/user',

  //speech token api's
  getSpeechToken: '/api/v2/pal/speech/token',

  //analytics api's
  getPbiAccessToken: '/api/v1/analytics/token',
  getpbiEmbedToken: '/api/v2/analytics/embed_token',
  getAnalyticsReportsList: '/api/v2/analytics/reports',
  refreshReportsList: 'https://api.powerbi.com/v1.0/myorg/groups/<workspace_ID>/datasets/<Dataset_ID>/refreshes',
  getRefreshAccessToken: '/api/v2/analytics/token',
  refreshAnalyticsReport: '/api/v2/analytics/refresh',
  getAnalysticsSearch: '/api/v2/analytics_search',
  askAgenticAnalytics: '/api/v1/ask',
  askDecisionAnalytics: '/api/v1/decision/ask',
  getAnalystSkills: '/analyst/skills',
  createAnalyst: '/api/v1/aides',
  postAidesUsage: '/api/v1/aides',

  //aiworker api's
  getAiWorkersByCategory: '/api/v1/aiworkers',
  getAiWorkersBySourceType: '/api/v1/sources',
  getAiWorkerById: '/api/v1/aiworkers',
  updateAiWorkers: '/api/v1/aiworkers',
  createAiWorkers: '/api/v1/aiworkers',
  deleteAiWorkers: '/api/v1/aiworkers',
  getMlEndPoints: '/api/v1/aiworkers/mlendpoints',
  deployPublicEndpoint: '/api/v1/external/public_endpoints/deploy',
  getAiWorkersUsageByCategory: '/api/v1/aiworkers/usage',
  getTemplateUsagePdf: '/api/v1/external-sharing/aiworkers-usage',
  getPresignedURl: `/api/v1/aiworkers/sources/upload/generate`,
  getAidesPresignedUrl: `/api/v1/presignedurl/generate`,
  updateAgentFeedback: '/api/v1/aiworkers/usage/feedback',
  getAgentPresignedUrl: `/api/v1/presignedurl/view`,
  getEvaluationsPresignedUrl: `/api/v1/presignedurl/view/by-key`,
  getPresignedUrlListKey: `/api/v1/presignedurl/list-key`,
  getPresignedUrlViewByKey: `/api/v1/presignedurl/view/by-key`,

  //actions api's
  updateAction: '/api/v1/source',
  actionIntegrations: '/api/v3/integrations',
  getPyAnalystEndpoints: '/api/v3/integrations/endpoints?type=pyanalyst',
  postExplainerTraceAndReasoning: '/api/v1/explainer/trace_reason',


  //circuit api's
  circuitConnector: '/api/v1/integrations',

  //explain Answer api
  getExplainAnswer: '/api/v1/explainer',

  //knowledge article
  uploadKnowledgeArticle: '/api/v2/knowledge/article',
  getKnowledgeArticle: '/api/v2/knowledge/article',
  getGuestKnowledgeArticle: '/rest/v2/knowledge/article',
  deleteKnowledgeArticle: '/api/v2/knowledge/article',
  delinkKnowledgeArticle: '/api/v2/knowledge/article',

  //ontology
  updateOntology: '/api/v1/ontology/updation',
  viewOntologyTerms: '/api/v2/ontology/view',
  ontologyGraphUpdate: '/api/v2/ontology/terms/graph-update',
  ontologyTermsAction: '/api/v2/ontology/terms/action',

  //SSO api's
  downloadSSOSAMLFile: '/api/v1/sso/getfile',
  ssoConnectionPath: '/api/v1/sso/connection',
  getSSOConnectionDetails: '/api/v1/sso/tenant/connections',

  //API Keys 
  apiKeysList: '/api/v1/api_keys/tenant?api_type=tenant_id',
  apiKeys: '/api/v1/api_keys',

  //Credentials
  credentialsList: '/api/v1/credentials',
  credentials: '/api/v1/credentials',

  // Data connectors (settings)
  dataConnectors: '/api/v1/data_connectors',

  //PDF Scanner api's
  getPDFPresignedURL: `/api/v1/knowledge/upload/generate`,
  getAgentsJSON: `/api/v1/agents/retrieve_json`,
  getClaimsScore: `/api/v1/connector/claims_score`,
  uploadAgentImage: `/api/v1/aiworkers/sources/upload/generate`,
  getImageModalData: `/api/v1/integrations`,

  //agent api's 
  agentTicketCreation: '/api/v1/integrations',
  uploadAiWorkerSources: '/api/v1/aiworker/source',
  agentFileUpload: '/api/v1/aiworkers/sources',
  configurationManagementQuery: '/api/v1/configuration_management/query',
  configurationManagement: '/api/v1/configuration_management',

  //Orgs
  getUserOrganisations: '/api/v2/tenant/user',

  //cart
  updateCartItem: '/api/v1/cart/item',
  getCartItems: '/api/v1/cart/item',
  deleteCartItem: '/api/v1/cart',
  deleteItemInCart: '/api/v1/cart/item',
  getCartCsvFile: '/api/v1/cart',

  //prompt api's
  getPromptInstructions: '/api/v1/prompts',
  updatePromptSettings: '/api/v1/prompts',

  //zip file api's
  getPartsZipComponents: '/api/v1/catalog',
  getPartsZipComponentDetails: '/api/v1/parts',

  //integrations api's
  integrationsUrl: '/api/v1/integrations',

  //tags api's
  getTags: '/api/v1/tags',

  //bot data and workflow data

  getData: '/api/v2/data/query',
  updateData: '/api/v2/data/update',


  //agent History 
  getAgentHisotry: '/api/v1/aiworkers/usage/query',
  exportAiWorkerUsage: '/api/v1/aiworkers/usage/query/export',
  getAiWorkersUsageEvents: '/api/v1/aiworkers_usage/events',

  //advanced settings 
  advancedSettings: '/api/v2/configurations',

  //triage api's
  getTriageQuery: '/api/v1/feedback-triage/query',
  updateTriage: '/api/v1/feedback-triage',
  getTriageDetails: '/api/v1/feedback-triage',
  getTriageJiraAssignableUsers: '/api/v1/feedback-triage/jira/assignable-users',
  getOrgUsers: '/api/v2/users',
  queryOrgUsers: '/api/v2/users/query',
  downloadConversation: '/api/v1/external-sharing/conversations',
  shareConversationMail: '/api/v1/external-sharing/converse/mail',

  // notification service
  getNotificationCatalog: '/api/v1/notification-service/catalog',
  getNotificationConfig: '/api/v1/notification-service/config',
  getNotificationWatchlist: '/api/v1/notification-service/watchlist',
  getEmailSubscription: '/api/v1/notification-service/email-subscription',
  resubscribeEmail: '/api/v1/notification-service/email-subscription/resubscribe',

  //workflow api's
  getWorkflows: '/api/v1/workflows',
  getWorkflowById: '/api/v1/workflows',
  createWorkflow: '/api/v1/workflows',
  updateWorkflow: '/api/v1/workflows',
  deleteWorkflow: '/api/v1/workflows',
  runWorkflow: '/api/v1/workflows',
  getNodeTypes: '/api/v1/workflows/node-types',
  //scheduler api's
  getSchedules: '/api/v1/scheduler',
  createSchedule: '/api/v1/scheduler',
  updateSchedule: '/api/v1/scheduler',
  deleteSchedule: '/api/v1/scheduler',
  runSchedule: '/api/v1/scheduler',
  getScheduleDetails: '/api/v1/scheduler',
  getSchedulerHistory: '/api/v1/scheduler',
  getSchedulerBatchDetail: '/api/v1/scheduler_history',
  schedulerHealth: '/api/v1/scheduler/health',
  auditLogs: '/api/v1/audit_logs',
  auditLogsHistory: '/api/v1/audit_logs/history',
  reprocessClaims: '/api/v1/reprocess_claims',

  // datamodels
  getDatamodels: '/api/v1/datamodels',
  getDatamodelsMetrics: '/api/v1/datamodels/metrics',

  // mappers
  getMappers: '/api/v1/mappers',
  mapper: '/api/v1/mapper',
  generateMapper: '/api/v1/mapper/generate',
  executeMapper: '/api/v1/mapper/execute',

};

export default apiEndPoints;
